<div class="cart-simulation">
  <div class="cart-simulation__benefits">
    <div class="cart-simulation__band cart-simulation__benefit-row">
      <span>{{ 'employee.cart-simulation.benefits' | translate }}</span>
      <span class="cart-simulation__amount">
        {{ 'employee.cart-simulation.amount' | translate }}
      </span>
      <span>{{ 'employee.cart-simulation.funding-type' | translate }}</span>
    </div>

    @for (benefit of view().benefits; track benefit.benefitId) {
      <div class="cart-simulation__row cart-simulation__benefit-row">
        <span>{{ benefit.name | translate }}</span>
        <span class="cart-simulation__amount">{{ benefit.budget | flexyooNumber }}</span>
        <span>
          @for (budgetType of benefit.budgetTypes; track budgetType) {
            {{ 'employee.cart-simulation.budget-types.' + budgetType | translate }}
            @if (!$last) {
              +
            }
          } @empty {
            —
          }
        </span>
      </div>
    }
  </div>

  @if (view().balances.length) {
    <div class="cart-simulation__balances">
      <div class="cart-simulation__band">
        {{ 'employee.cart-simulation.balances' | translate }}
      </div>

      @for (balance of view().balances; track balance.budgetType) {
        <div class="cart-simulation__row cart-simulation__balance-row">
          <span>{{
            'employee.cart-simulation.budget-types.' + balance.budgetType | translate
          }}</span>
          <span class="cart-simulation__amount">{{ balance.amount | flexyooNumber }}</span>
        </div>
      }
    </div>
  }
</div>
